/* eslint-disable @typescript-eslint/camelcase */
import {
  ModelTypeEnum,
  InitialEnvironmentFields,
  CloudProviderEnum,
  EnvironmentStatus,
} from 'modules/environments/interfaces';

export const initial: InitialEnvironmentFields = {
  env_status: EnvironmentStatus.PENDING,
  completion_date: null,
  completion_date_change_request: false,
  completion_date_reason: '',
  completion_date_extendable: false,
  in_maintenance: false,
  completion_date_proposed: null,
  completion_date_request_by: {
    operator_uuid: '',
    first_name: '',
    last_name: '',
    email: '',
  },
  name: '',
  partner_uuid: '',
  easysky_project_id: '',
  trusted_users: '',
  product_type: 'dedicated',
  product: 'autosky',
  provider: {
    type: CloudProviderEnum.AWS,
    region: 'us-east-1',
    compartment_id: '',
    oci_config_profile_name: null,
  },
  behavior: {
    type: '',
    timezone: 'America/Sao_Paulo',
    comments: '',
  },
  licenses: {
    license_limit: 0,
    increase_license_limit_each: 0,
    increase_license_reason: null,
    control_licenses_by_client: false,
    block_same_user_multiple_session: false,
    bypass_increase_license_auto_disable: false,
  },
  user_connection: {
    virtualizer: 'connect',
    service_port: 491,
    web_port: null,
    quality: 'high',
    https_proxy: '',
    network_type: 'public',
    connect_by_dns_domain_name: true,
    allow_client_connection_type: false,
    use_ios_by_default: false,
    unique_user_session_validation: false,
  },
  scale_instances: {
    main_model_uuid: '',
    backup_model_uuid: '',
    spot_model_uuid: '',
    spot_threshold: 0,
    is_creating: false,
    num_instances_being_created: 0,
  },
  publication: {
    type: ModelTypeEnum.customImage,
    limit_instance_blocking_publications: 3,
    limit_instance_blocking_publications_daily: null,
    executed_instance_blocking_publications: 0,
    executed_instance_blocking_publications_daily: 0,
    publication_can_block_old_instances: false,
    schedule_instances_blocking_check: 'false',
    schedule_instances_blocking: {
      time: new Date(),
      warning_emails: '',
    },
  },
  client_apps: {
    registration_source: 'autosky',
    registration_mode: 'simple',
  },
  password_policy: {
    min_length: 8,
    expire_passwords: true,
    expire_days: 60,
    max_auth_tries: 8,
    check_history: true,
    check_complexity: true,
  },
  device_validation_settings: {
    device_validation_enabled: true,
    environment_admin_pin: '',
  },
  user_access_without_ad: {
    enabled: false,
  },
};
